import { Metric } from 'web-vitals';

function reportWebVitalsHandler(metric: Metric) {
  console.log(metric);
}

export default reportWebVitalsHandler;
